import {
  Divider,
  Flex,
  FormControl,
  Grid,
  ModalBody,
  ModalHeader,
  Select,
  Text,
  Box,
  ModalCloseButton,
  Textarea,
} from "@chakra-ui/react";
import MyDiv from "./rejectedCard.style";
import { CustomButton, CustomToast } from "../../../../../components";
import { useState } from "react";
import { useFetch } from "../../../../../hooks/useFetch";

type RejectedCardProps = {
  onClose: () => void;
  candidateDetail: any;
  interviewResult: number;
  reload: boolean;
  setReload: React.Dispatch<React.SetStateAction<boolean>>;
};

const RejectedCard = ({ onClose, candidateDetail, interviewResult, reload, setReload }: RejectedCardProps) => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);

  const [selectedReason, setSelectedReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleRejectedSubmit = async () => {
    if (!candidateDetail) {
      addToast({ message: "Candidate details not found.", status: "error" });
      return;
    }

    if (!selectedReason) {
      addToast({ message: "Please select a reason before submitting.", status: "warning" });
      return;
    }

    let finalReason = selectedReason === "other" ? customReason.trim() : selectedReason;

    if (!finalReason) {
      addToast({ message: "Please provide a reason before submitting.", status: "warning" });
      return;
    }

    const payload = {
      candidate_Id: candidateDetail.id,
      interview_Result: interviewResult ?? 5, // 5 = Rejected
      rejected_Reason: finalReason,
    };

    try {
      setIsSubmitting(true);
      const response = await fetchApi("Candidate/interviewStatusChange", "POST", payload, "", "");
      if (response) {
        addToast({ message: "Candidate rejected successfully.", status: "success" });
        onClose();
        setReload(!reload)
      }
    } catch (error) {
      addToast({ message: "Failed to update candidate status. Please try again.", status: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <MyDiv>
      <ModalHeader textAlign="center" className="font-poppins text_medium text_xxl">
        Candidate Rejected the Offer
      </ModalHeader>
      <ModalCloseButton />
      <Divider />
      <ModalBody>
        <Grid gap={4}>
          <Flex justifyContent="space-between">
            <Text className="font-poppins text_md text_medium">Candidate Name</Text>
            <Text className="font-poppins text_md text_regular">{candidateDetail?.candidate_Name}</Text>
          </Flex>
          <Flex justifyContent="space-between">
            <Text className="font-poppins text_md text_medium">Candidate Email</Text>
            <Text className="font-poppins text_md text_regular">{candidateDetail?.email}</Text>
          </Flex>

          <FormControl>
             <Text className="font-poppins text_md text_medium" mb={2}>Select Reason</Text>
            <Select placeholder="Please select reason" value={selectedReason} onChange={(e) => setSelectedReason(e.target.value)} >
              <option value="Salary mismatch">Salary mismatch</option>
              <option value="Role mismatch">Role mismatch</option>
              <option value="Personal reasons">Personal reasons</option>
              <option value="other">Other</option>
            </Select>
          </FormControl>

          {selectedReason === "other" && (
            <FormControl>
              <Text className="font-poppins text_md text_medium" mb={1}> Reason </Text>
              <Textarea value={customReason} onChange={(e) => setCustomReason(e.target.value)} placeholder="Explain your reason" rows={5} resize="vertical" className="font-poppins text_md text_regular" />
            </FormControl>
          )}

          <Box display="flex" justifyContent="flex-end" mt={4}>
            <CustomButton title={isSubmitting ? "Submitting..." : "Submit"} className="btn font-poppins text_sm text_medium" onClick={handleRejectedSubmit} isDisabled={isSubmitting} />
          </Box>
        </Grid>
      </ModalBody>
    </MyDiv>
  );
};

export default RejectedCard;
